import { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik'

import * as Yup from 'yup'

import { Context } from 'contexts/context'

import TitleBar from 'components/TitleBar'
import Content from 'components/Content'
import Card from 'components/Card'
import CardTitle from 'components/CardTitle'
import Input from 'components/Form/LabelInput'
import BtnBlue from 'components/Button/BtnBlue'
import Select from 'components/Form/LabelSelect'
import Messages from 'components/Messages'
import Spinner from 'components/Spinner'
import CardBody from 'components/CardBody'
import BtnBox from 'components/Button/BtnBox'

import { handleChatbotStore } from 'services/api/chatbot'
import { handleCards } from 'services/api/reportCards'

const validation = yup => ({
  name: yup.string()
    .required('Campo obrigatório')
})

const NewReportCollection = () => {
  const [messages, setMessages] = useState({ messages: [], alert: '' })

  const [cards, setCards] = useState([])

  const { user: { firm_id } } = useContext(Context)

  const history = useHistory()

  const formik = useFormik({
    initialValues: {
      name: ''
    },
    validationSchema: Yup.object(validation(Yup)),
    onSubmit: async () => handleChatbotStore(history, formik.values, setMessages)
  })

  useEffect(() => {
    (async () => {
      try {
        setCards(await handleCards(firm_id))
      } catch (error) { }
    })()
  }, [firm_id])

  return (
    <>
      <TitleBar label="Chatbot" currentPage="" />

      <Content>
        <Card>
          <CardTitle title="Cadastrar"></CardTitle>

          <Content>
            <CardBody>
              <form onSubmit={formik.handleSubmit}>
                <Messages formMessages={messages.messages} alert={messages.alert} />

                <Input name="name" label="Nome" formik={formik} />

                <BtnBox>
                  <BtnBlue type="submit" disabled={formik.isSubmitting}>
                    {formik.isSubmitting ? <Spinner /> : "Enviar"}
                  </BtnBlue>
                </BtnBox>
              </form>
            </CardBody>
          </Content>
        </Card>
      </Content>
    </>
  )
}

export default NewReportCollection